import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { formatCPF, formatPhone, validateCPF, validateAge } from '../utils/helpers';

export default function RegisterPage() {
  const { token } = useParams();
  const navigate  = useNavigate();
  const [inviter, setInviter]   = useState(null);
  const [invalid, setInvalid]   = useState(false);
  const [success, setSuccess]   = useState(false);
  const [loading, setLoading]   = useState(false);
  const [errors, setErrors]     = useState({});
  const [form, setForm] = useState({
    login:'', password:'', confirmar_senha:'',
    nome:'', cpf:'', data_nascimento:'',
    nome_mae:'', municipio:'', telefone:'', tipo:'', email:''
  });

  useEffect(() => {
    axios.get(`/api/auth/invite/${token}`)
      .then(r => setInviter(r.data.inviter))
      .catch(() => setInvalid(true));
  }, [token]);

  const set   = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const upper = (k)    => (v) => set(k, v.toUpperCase());

  const validate = () => {
    const e = {};
    if (!validateCPF(form.cpf.replace(/\D/g,''))) e.cpf = 'CPF inválido';
    if (!validateAge(form.data_nascimento))        e.data_nascimento = 'Necessário ter 18 anos ou mais';
    if (form.password.length < 6)                  e.password = 'Mínimo 6 caracteres';
    if (form.password !== form.confirmar_senha)    e.confirmar_senha = 'Senhas não conferem';
    if (!form.tipo)                                e.tipo = 'Selecione um tipo';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'E-mail inválido';
    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setLoading(true);
    try {
      await axios.post('/api/auth/register', { ...form, invite_token: token });
      setSuccess(true);
    } catch (err) {
      setErrors({ submit: err.response?.data?.error || 'Erro ao cadastrar' });
    } finally { setLoading(false); }
  };

  const roleNextLabel = {
    ADMIN:'Coordenador Geral', COORDENADOR_GERAL:'Coordenador Municipal',
    COORDENADOR_MUNICIPAL:'Liderança', LIDERANCA:'Apoiador', APOIADOR:'Apoiador'
  };

  if (invalid) return (
    <div className="auth-container">
      <div className="auth-card" style={{ textAlign:'center' }}>
        <div style={{ fontSize:48 }}>⚠️</div>
        <h2 style={{ color:'var(--danger)', marginTop:12 }}>Link inválido ou expirado</h2>
        <p style={{ color:'var(--text)', marginTop:8 }}>Solicite um novo link ao seu coordenador.</p>
      </div>
    </div>
  );

  if (success) return (
    <div className="auth-container">
      <div className="auth-card" style={{ textAlign:'center' }}>
        <div style={{ fontSize:48 }}>✅</div>
        <h2 style={{ color:'var(--primary)', marginTop:12 }}>Cadastro realizado!</h2>
        <p style={{ color:'var(--text)', margin:'12px 0 24px' }}>Aguarde a ativação pelo administrador.</p>
        <button className="btn" onClick={() => navigate('/')}>IR PARA O LOGIN</button>
      </div>
    </div>
  );

  if (!inviter) return (
    <div className="auth-container">
      <div className="loading-screen"><div className="spinner" /><span>Carregando...</span></div>
    </div>
  );

  const F = ({ label, children, error }) => (
    <div className="field-group">
      <label className="r-label">{label}</label>
      {children}
      {error && <span className="field-error">{error}</span>}
    </div>
  );

  return (
    <div className="auth-container" style={{ alignItems:'flex-start', padding:'24px 16px' }}>
      <div className="auth-card" style={{ maxWidth:560, margin:'0 auto' }}>
        <div className="auth-logo">
          <img src="/favicon.ico" alt="Logo" style={{ width:52, height:52, objectFit:"contain", marginBottom:4 }} />
          <h1 className="auth-title">NOVO CADASTRO</h1>
          <p style={{ color:'var(--text)', fontSize:13, margin:'4px 0' }}>
            Convidado por: <strong>{inviter.nome}</strong>
          </p>
          <span className="side-badge">Perfil: {roleNextLabel[inviter.role]}</span>
        </div>

        <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:14 }}>
          {/* ACESSO */}
          <div className="section-divider"><span>DADOS DE ACESSO</span></div>
          <div className="grid-2">
            <F label="Login" error={errors.login}>
              <input className={`r-input${errors.login?' error':''}`} value={form.login}
                onChange={e => set('login', e.target.value.toLowerCase())} required />
            </F>
            <F label="Senha" error={errors.password}>
              <input type="password" className={`r-input${errors.password?' error':''}`}
                value={form.password} onChange={e => set('password', e.target.value)} required />
            </F>
          </div>
          <F label="Confirmar Senha" error={errors.confirmar_senha}>
            <input type="password" className={`r-input${errors.confirmar_senha?' error':''}`}
              value={form.confirmar_senha} onChange={e => set('confirmar_senha', e.target.value)} required />
          </F>

          {/* E-MAIL */}
          <F label="E-MAIL" error={errors.email}>
            <input
              type="email"
              className={`r-input${errors.email?' error':''}`}
              value={form.email}
              onChange={e => set('email', e.target.value.toLowerCase())}
              placeholder="seu@email.com"
              required
            />
            <span style={{ fontSize:11, color:'#888', marginTop:4, display:'block', lineHeight:1.5 }}>
              📧 Para recuperar sua senha, um link será enviado para este e-mail.
            </span>
          </F>

          {/* PESSOAIS */}
          <div className="section-divider"><span>DADOS PESSOAIS</span></div>
          <F label="Nome Completo">
            <input className="r-input" value={form.nome}
              onChange={e => upper('nome')(e.target.value)} required />
          </F>
          <div className="grid-2">
            <F label="CPF" error={errors.cpf}>
              <input className={`r-input${errors.cpf?' error':''}`} value={form.cpf}
                onChange={e => set('cpf', formatCPF(e.target.value))} placeholder="000.000.000-00" required />
            </F>
            <F label="Data de Nascimento" error={errors.data_nascimento}>
              <input type="date" className={`r-input${errors.data_nascimento?' error':''}`}
                value={form.data_nascimento} onChange={e => set('data_nascimento', e.target.value)} required />
            </F>
          </div>
          <F label="Nome da Mãe">
            <input className="r-input" value={form.nome_mae}
              onChange={e => upper('nome_mae')(e.target.value)} required />
          </F>
          <div className="grid-2">
            <F label="Município">
              <input className="r-input" value={form.municipio}
                onChange={e => upper('municipio')(e.target.value)} required />
            </F>
            <F label="Celular / WhatsApp">
              <input className="r-input" value={form.telefone}
                onChange={e => set('telefone', formatPhone(e.target.value))}
                placeholder="(65) 99999-9999" required />
            </F>
          </div>
          <F label="Tipo" error={errors.tipo}>
            <select className={`r-select${errors.tipo?' error':''}`} value={form.tipo}
              onChange={e => set('tipo', e.target.value)} required>
              <option value="">Selecione...</option>
              <option value="PREFEITO">Prefeito</option>
              <option value="VEREADOR">Vereador</option>
              <option value="LIDERANCA">Liderança</option>
              <option value="OUTROS">Outros</option>
            </select>
          </F>

          {errors.submit && <div className="alert alert-danger">{errors.submit}</div>}
          <button type="submit" className="btn" disabled={loading}
            style={{ padding:'13px', fontSize:13, letterSpacing:2, marginTop:6 }}>
            {loading ? 'CADASTRANDO...' : 'FINALIZAR CADASTRO'}
          </button>
        </form>
      </div>
    </div>
  );
}
